export default {
    proposalStats: [],
    applicationsUnderReview: [],
    applicationsSignedOff: []
};
